const initState = {
    templates: [],
    initialTemplates: [],
    templateProducts: []
};

export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_INITIAL_TEMPLATES = 'SET_INITIAL_TEMPLATES';
export const SET_TEMPLATE_PRODUCTS = 'SET_TEMPLATE_PRODUCTS';

export const setTemplates = (data) => ({ type: SET_TEMPLATES, payload: data });
export const setInitialTemplates = (data) => ({ type: SET_INITIAL_TEMPLATES, payload: data });
export const setTemplateProducts = (data) => ({ type: SET_TEMPLATE_PRODUCTS, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_TEMPLATES:
            return { ...state, templates: action.payload };
        case SET_INITIAL_TEMPLATES:
            return { ...state, initialTemplates: action.payload };
        case SET_TEMPLATE_PRODUCTS:
            return { ...state, templateProducts: action.payload };
        default:
            return state
    }
}
